const locale = {
	Profile: "Perfil",
};

export default locale;
